import type { Command, CommandContext } from "./Command";
import { getComponent, withComponent } from "../../world/Entity";
import type { EntityId } from "../../world/Entity";
import type { Vec2 } from "../../world/geometry";

/** Attaches `entityId` to a surface entity (table, shelf, ...) at a local offset within its bounds. */
export class PlaceFurnitureCommand implements Command {
  constructor(
    private readonly entityId: EntityId,
    private readonly surfaceEntityId: EntityId,
    private readonly localOffset: Vec2,
  ) {}

  execute(context: CommandContext): void {
    const surface = context.world.getEntity(this.surfaceEntityId);
    if (!surface) throw new Error(`Unknown surface entity "${this.surfaceEntityId}"`);
    const surfaceComponent = getComponent(surface, "surface");
    if (!surfaceComponent) throw new Error(`Entity "${this.surfaceEntityId}" is not a surface`);

    context.world.updateEntity(this.surfaceEntityId, (e) =>
      withComponent(e, "surface", (s) => ({
        ...s,
        occupants: s.occupants.includes(this.entityId) ? s.occupants : [...s.occupants, this.entityId],
      })),
    );

    const worldPosition: Vec2 = {
      x: surface.transform.position.x + this.localOffset.x,
      y: surface.transform.position.y + this.localOffset.y,
    };
    context.world.moveEntity(this.entityId, { position: worldPosition });

    context.events.emit("item:placed", { entityId: this.entityId, surfaceEntityId: this.surfaceEntityId });
  }
}
